// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-background {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.login-background-image {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-background-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, transparent 30%, rgba(249, 250, 251, 0.95) 100%);
}

.login-floating-icons {
  position: absolute;
  inset: 0;
  z-index: 10;
  overflow: hidden;
}

.login-icon {
  position: absolute;
  border-radius: 0.75rem;
  padding: 1rem;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  animation: float 6s ease-in-out infinite;
}

.login-icon:nth-child(1) {
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
  animation-delay: 0s;
}

.login-icon:nth-child(2) {
  right: 25%;
  top: 25%;
  transform: translate(50%, -50%);
  animation-delay: 1.5s;
}

.login-icon:nth-child(3) {
  left: 33%;
  bottom: 33%;
  transform: translate(-50%, 50%);
  animation-delay: 3s;
}

.login-icon:nth-child(4) {
  right: 33%;
  bottom: 33%;
  transform: translate(50%, 50%);
  animation-delay: 4.5s;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

.login-form-container {
  z-index: 20;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 28rem;
}

@media (max-width: 640px) {
  .login-background-overlay {
    background: radial-gradient(circle at center, transparent 10%, rgba(249, 250, 251, 0.98) 70%);
  }
  
  .login-form-container {
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/LoginBackground.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8FAA8F;AAChG;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,6FAA6F;EAC/F;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".login-background {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.login-background-image {\n  height: 100%;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.login-background-overlay {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at center, transparent 30%, rgba(249, 250, 251, 0.95) 100%);\n}\n\n.login-floating-icons {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  overflow: hidden;\n}\n\n.login-icon {\n  position: absolute;\n  border-radius: 0.75rem;\n  padding: 1rem;\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  animation: float 6s ease-in-out infinite;\n}\n\n.login-icon:nth-child(1) {\n  left: 25%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n  animation-delay: 0s;\n}\n\n.login-icon:nth-child(2) {\n  right: 25%;\n  top: 25%;\n  transform: translate(50%, -50%);\n  animation-delay: 1.5s;\n}\n\n.login-icon:nth-child(3) {\n  left: 33%;\n  bottom: 33%;\n  transform: translate(-50%, 50%);\n  animation-delay: 3s;\n}\n\n.login-icon:nth-child(4) {\n  right: 33%;\n  bottom: 33%;\n  transform: translate(50%, 50%);\n  animation-delay: 4.5s;\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.login-form-container {\n  z-index: 20;\n  background-color: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  width: 100%;\n  max-width: 28rem;\n}\n\n@media (max-width: 640px) {\n  .login-background-overlay {\n    background: radial-gradient(circle at center, transparent 10%, rgba(249, 250, 251, 0.98) 70%);\n  }\n  \n  .login-form-container {\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
